import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonBadge, IonButton, IonIcon, IonToggle } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { colorWandSharp, backspaceSharp } from 'ionicons/icons';
import { PuzzleGameState } from '../../store/puzzle-game.state';
import { PuzzleGameModel } from '../../store/puzzle-game.model';
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { Button } from '../../shared-module/buttons/button.def';
import { DisableNotesMode, EnableNotesMode } from '../../store/puzzle-notes-mode.actions';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ng2-tooltip-directive-major-angular-updates';

export enum SudokuKeyboardLayouts {
  DEFAULT_BOTTOM,
  DEFAULT_RIGHT,
  FLAT_BOTTOM,
  TWO_ROW_BOTTOM,
  THREE_COL_RIGHT,
}

@Component({
  selector: 'lib-app-sudoku-keyboard',
  templateUrl: './sudoku-keyboard.component.html',
  styleUrls: ['./sudoku-keyboard.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, TooltipModule, TranslateModule, IonBadge, IonButton, IonIcon, IonToggle],
})
export class SudokuKeyboardComponent implements OnDestroy {
  @Output() puzzleKeyPressed = new EventEmitter<string>();
  @Input() enabledInputs: string[] = [];

  @Input() disableDeleteButton: boolean;
  @Input() disableJokerButton: boolean;

  @Input() keyboardLayout: SudokuKeyboardLayouts = SudokuKeyboardLayouts.DEFAULT_BOTTOM;

  SudokuKeyboardLayouts = SudokuKeyboardLayouts;

  private puzzleGameSubscription: Subscription;
  private puzzleID: string;

  notesMode: boolean;

  noMargin = false;

  jokerCount: number;

  saveVerticalSpace = false;

  private puzzleGame$: Observable<any>;

  constructor(private store: Store, private framework: PuzzleFrameworkService) {
    addIcons({
      colorWandSharp,
      backspaceSharp,
    });
    this.noMargin = this.framework.puzzleFrameworkConfig.removeSideMargins;

    this.store
      .select((state) => state.notesModeState)
      .subscribe((enabled) => {
        if (this.notesMode !== enabled) {
          this.notesMode = enabled;
        }
      });

    this.store
      .select((state) => state.puzzleID)
      .subscribe((puzzleID) => {
        if (puzzleID === '') {
          return;
        }

        if (this.puzzleGameSubscription) {
          this.puzzleGameSubscription.unsubscribe();
        }

        this.puzzleID = puzzleID;

        this.puzzleGame$ = this.store.select(PuzzleGameState.getByID(puzzleID));
        this.puzzleGameSubscription = this.puzzleGame$.subscribe((puzzleGame: PuzzleGameModel) => {
          if (!puzzleGame) {
            return;
          }
          this.jokerCount = puzzleGame.jokerCount;
        });
      });
  }

  ngOnDestroy(): void {
    if (this.puzzleGameSubscription) {
      this.puzzleGameSubscription.unsubscribe();
    }
  }

  keyPressed(input: string) {
    this.puzzleKeyPressed.emit(input);
  }

  setNoteMode() {
    if (this.notesMode) {
      this.store.dispatch(new DisableNotesMode());
    } else {
      this.store.dispatch(new EnableNotesMode());
    }
  }

  solveField() {
    if (this.jokerCount > 0) {
      this.framework.buttonBarEmitButton(Button.Joker);
    }
  }
}
